/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import ComposeMessageButton from '../../compose/components/ComposeMessageButton';
import CustomViewsFooterLink from './CustomViewsFooterLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getAvailabilityManagementUrl } from 'conversations-external-deep-links/urls';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { hasConfiguredEmail as getHasConfiguredEmail } from '../../connected-accounts/selectors/hasConfiguredEmail';
import { getIsConversationsAdmin } from '../../selectors/userSelectors/getIsConversationsAdmin';
import { getHasAvailabilityManagementWriter } from '../../selectors/userSelectors/getHasAvailabilityManagementWriter';
import { getSelectChannelUrl } from '../../unified-inbox/operators/getSelectChannelUrl';
import { getUserHasCustomViewsAccess } from '../../selectors/userSelectors/getUserHasCustomViewsAccess';
import { trackConnectChannel } from '../../unified-inbox/operators/trackConnectChannel';
import { trackLinkClick } from '../../usage-tracking/utils/trackLinkClick';
import { withFromInbox } from '../../urls/withFromInbox';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getIsAdminNotMemberOfInbox } from '../../unified-inbox/selectors/getIsAdminNotMemberOfInbox';
import WhatsAppCoachingModal from '../../whatsapp/WhatsAppCoachingModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionsWrapper = styled.div.withConfig({
  displayName: "FooterActionsSection__ActionsWrapper",
  componentId: "sc-1qzxehx-0"
})(["display:flex;flex:1;"]);
const FooterActions = ({
  onCreateCustomViewClick
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('custom-views-inbox-footer-actions');
  const inboxId = useSelector(getCurrentInboxId);
  const isAdmin = useSelector(getIsConversationsAdmin);
  const hasAMWrite = useSelector(getHasAvailabilityManagementWriter);
  const userHasCustomViewsAccess = useSelector(getUserHasCustomViewsAccess);
  if (!isAdmin && !userHasCustomViewsAccess) {
    return null;
  }
  const handleTeamAvailabilityClick = event => {
    trackLinkClick({
      event,
      name: 'opened-inbox-settings',
      meta: {
        action: 'opened inbox settings',
        setting: 'team'
      },
      href: getAvailabilityManagementUrl()
    });
  };
  const handleConnectChannelClick = trackConnectChannel({
    href: withFromInbox(getSelectChannelUrl(inboxId), true)
  });
  return /*#__PURE__*/_jsx(WhatsAppCoachingModal, {
    children: /*#__PURE__*/_jsx(ActionsWrapper, {
      children: /*#__PURE__*/_jsx(UIDropdown, {
        buttonClassName: "width-100",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.buttons.actions"
        }),
        buttonUse: "tertiary-light",
        buttonSize: "small",
        "data-test-id": "nav-sidebar-footer-actions-dropdown",
        popoverProps: {
          placement: 'top right'
        },
        children: /*#__PURE__*/_jsxs(UIList, {
          children: [hasAMWrite && /*#__PURE__*/_jsx(UIButton, {
            onClick: handleTeamAvailabilityClick,
            "data-test-id": "team-availability-button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.viewsSidebar.actions.teamAvailability"
            })
          }), /*#__PURE__*/_jsx(CustomViewsFooterLink, {
            openUpgradeModal: openUpgradeModal,
            onCreateCustomViewClick: onCreateCustomViewClick
          }), isAdmin && /*#__PURE__*/_jsx(UIButton, {
            onClick: handleConnectChannelClick,
            "data-test-id": "connect-channel-button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.viewsSidebar.actions.connectChannel"
            })
          })]
        })
      })
    })
  });
};
FooterActions.displayName = 'FooterActions';
const ButtonsWrapper = styled.div.withConfig({
  displayName: "FooterActionsSection__ButtonsWrapper",
  componentId: "sc-1qzxehx-1"
})(["display:flex;border-top:1px solid ", ";width:100%;padding:12px;"], GREAT_WHITE);
const ComposeWrapper = styled.div.withConfig({
  displayName: "FooterActionsSection__ComposeWrapper",
  componentId: "sc-1qzxehx-2"
})(["display:flex;flex:2;margin-left:8px;"]);
const FooterActionsSection = ({
  onCreateCustomViewClick
}) => {
  const hasConfiguredEmail = useSelector(getHasConfiguredEmail);
  const hasCustomViewsAccess = useSelector(getUserHasCustomViewsAccess);
  const isAdmin = useSelector(getIsConversationsAdmin);
  const isAdminNotMemberOfInbox = useSelector(getIsAdminNotMemberOfInbox);
  if (!isAdmin && !hasCustomViewsAccess && !hasConfiguredEmail) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ButtonsWrapper, {
    children: [/*#__PURE__*/_jsx(FooterActions, {
      onCreateCustomViewClick: onCreateCustomViewClick
    }), hasConfiguredEmail && !isAdminNotMemberOfInbox && /*#__PURE__*/_jsx(ComposeWrapper, {
      children: /*#__PURE__*/_jsx(ComposeMessageButton, {
        className: "width-100",
        size: "small",
        use: "tertiary"
      })
    })]
  });
};
FooterActionsSection.displayName = 'FooterActionsSection';
export default FooterActionsSection;